import InsetSheet from './InsetSheet'

export * from './InsetSheet'

export default InsetSheet
